import {BASE_URL} from '@/services/api'
import {METHOD, request} from '@/utils/request'


let LOGIN =  `${BASE_URL}/userlogin`
let CHECK_CODE = `${BASE_URL}/checkCode`
let CHECK_VCODE = `${BASE_URL}/login/checkVcode`
let REFRESH_TOKEN = `${BASE_URL}/refreshToken`
let REFRESH_USERINFO =`${BASE_URL}/refreshUserInfo`
let VERIFY_LOGINID =`${BASE_URL}/verifyLoginID`
let VERIFY_MAIL =`${BASE_URL}/verifyMail`
let CHECK_VERIFY_CODE =`${BASE_URL}/checkVerifyCode`
let UPDATE_PASSWORD =`${BASE_URL}/updatePassword`
let CKECK_LOGIN_REQUEST = `${BASE_URL}/checkLoginRequest`
let GET_REFRESH_TOKEN = `${BASE_URL}/getRefreshToken`

/**
 * 登录服务
 * @param login_code 账户名
 * @param password 账户密码
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function Login(data) {
  return request(LOGIN, METHOD.POST, data)
}

/**
 * 验证code是否有效
 * @param code
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function CheckCode(data) {
  return request(CHECK_CODE, METHOD.POST, data)
}

/**
 * 验证二次验证code是否正确
 * @param code
 * @returns {Promise<AxiosResponse<T>>}
 */
export async function CheckAuthcode(refreshtoken,auth_code) {
  return request(CHECK_VCODE, METHOD.POST, {
    refreshtoken:refreshtoken,
    auth_code:auth_code
  })
}

export async function GetRefreshToken(params) {
  return request(GET_REFRESH_TOKEN, METHOD.POST, params)
}

export async function RefreshToken(params) {
  return request(REFRESH_TOKEN, METHOD.POST, params)
}

export async function RefreshUserInfo(params) {
  return request(REFRESH_USERINFO, METHOD.POST, params)
}

export async function VerifyLoginId(params) {
  return request(VERIFY_LOGINID, METHOD.POST, params)
}

export async function VerifyMail(params) {
  return request(VERIFY_MAIL, METHOD.POST, params)
}

export async function CheckVerifyCode(params) {
  return request(CHECK_VERIFY_CODE, METHOD.POST, params)
}

export async function UpdatePassword(params) {
  return request(UPDATE_PASSWORD, METHOD.POST, params)
}

export async function CheckLoginRequest(params) {
  return request(CKECK_LOGIN_REQUEST, METHOD.POST, params)
}

export default {
  RefreshToken
}
